import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Width (px) of the app's right-docked AI chat panel, read from the
 * `--agent-panel-width` CSS variable the app sets on the document root. Returns
 * 0 when the panel is closed/unset (and during SSR). Used so right-docked sheets
 * sit beside the panel and popovers steer clear of it via `collisionPadding`.
 */
export function agentPanelWidthPx(): number {
  if (typeof document === "undefined") return 0;
  const raw = getComputedStyle(document.documentElement).getPropertyValue(
    "--agent-panel-width",
  );
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) ? n : 0;
}
